import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Box } from '@mui/material';
import SectionNavigator from './SectionNavigator';
import { spacing } from 'common/theme';
import { generateTestId } from 'app/functions';
import { useTranslations } from 'common/hooks/useTranslations';
import * as routes from 'constants/routes';

const PersonalInfoMaster = ({ testID }) => {
  const history = useHistory();
  const { url } = useRouteMatch();
  const { translate } = useTranslations();

  return (
    <Box 
      sx={{ 
        width: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        gap: `${spacing.xs}px`,
        direction: 'rtl',
      }}
    >
      <SectionNavigator 
        testID={generateTestId(testID, 'nav-edit')}
        title={translate('personal_zone_personal_info_title')}
        onClick={() => history.push(`${url}${routes.user_info_routes.personal_info_edit}`)}
      />
      <SectionNavigator 
        testID={generateTestId(testID, 'nav-payment')}
        title={translate('personal_zone_payment_methods')}
        onClick={() => history.push(`${url}${routes.personal_zone_routes.payment_methods}`)}
      />
    </Box>
  );
};

export default PersonalInfoMaster;